import { Icon24AddCircleOutline } from '@vkontakte/icons';
import { Button } from '@vkontakte/vkui';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';

interface Props {
  onClick: () => void;
}

export const AttachFilesButton = ({ onClick }: Props) => {
  return (
    <Button
      mode="tertiary"
      before={<Icon24AddCircleOutline fill={baseTheme.colorIconSecondary.normal} />}
      onClick={onClick}
    />
  );
};
